
export class TargetObjectFilterOptions {
    targetObjectIds: Array<number>;
    platformIds: Array<number>;
    dataSetIds: Array<number>;
    dataOwnerIds: Array<number>;
    sourceObjectIds: Array<number>;
}
